import React, { useMemo, useState } from "react";
import "./kabuliyatnamaChecklist.css";

const beforeSigningItems = [
  "Full legal names and citizenship numbers of all parties",
  "Complete property address including ward number and municipality",
  "Monthly rent amount in words and numerals",
  "Payment date and accepted method",
  "Security deposit amount and return conditions",
  "Move-in condition report (or Annex A attached and signed)",
  "Dated photographs or video of property condition at move-in",
  "Notice period for vacating (tenant and landlord)",
  "Rent increase conditions and maximum frequency",
  "Utility responsibility: water (KUKL, tanker), electricity, internet",
  "Water pump and tank maintenance responsibility",
  "Structural repair responsibility (particularly monsoon damage)",
  "Number of permitted occupants (named)",
  "Subletting policy",
  "Pet policy",
  "Permitted property use (residential/commercial/home business)",
  "Landlord's right of entry notice requirement",
  "Key handover record (number of sets)",
  "Alteration and improvement policy",
  "Dispute resolution mechanism and jurisdiction",
];

const beforePaymentItems = [
  "You have physically visited and inspected the interior of the property",
  "The person receiving payment has demonstrated they own or are authorized to rent the property",
  "You have received a signed, dated receipt for any advance or deposit payment",
  "You have a fully signed copy of the agreement for your own records",
];

const allItems = [...beforeSigningItems, ...beforePaymentItems];

export default function KabuliyatnamaChecklist() {
  const [checked, setChecked] = useState(() => allItems.map(() => false));

  const checkedCount = useMemo(() => checked.filter(Boolean).length, [checked]);
  const percent = Math.round((checkedCount / allItems.length) * 100);

  function toggle(index) {
    setChecked((prev) => {
      const copy = [...prev];
      copy[index] = !copy[index];
      return copy;
    });
  }

  function setAll(value) {
    setChecked(allItems.map(() => value));
  }

  return (
    <section
      className="kabu-checklist"
      aria-label="Kabuliyatnama readiness checklist"
    >
      <div className="kabu-head">
        <h3>Kabuliyatnama Readiness Checklist</h3>
        <p>
          Progress: <b>{checkedCount}</b> / {allItems.length} ({percent}%)
        </p>
      </div>

      <div className="kabu-progress" aria-hidden="true">
        <span style={{ width: `${percent}%` }} />
      </div>

      <div className="kabu-actions no-print">
        <button type="button" onClick={() => setAll(true)}>
          Mark All
        </button>
        <button type="button" onClick={() => setAll(false)}>
          Clear All
        </button>
        <button type="button" onClick={() => window.print()}>
          Print Checklist
        </button>
      </div>

      <h4>Before signing, confirm the agreement includes:</h4>
      <ul className="kabu-list">
        {beforeSigningItems.map((item, i) => (
          <li key={item}>
            <label>
              <input
                type="checkbox"
                checked={checked[i]}
                onChange={() => toggle(i)}
              />
              <span>{item}</span>
            </label>
          </li>
        ))}
      </ul>

      <h4>Before handing over any money, confirm:</h4>
      <ul className="kabu-list">
        {beforePaymentItems.map((item, i) => {
          const idx = beforeSigningItems.length + i;
          return (
            <li key={item}>
              <label>
                <input
                  type="checkbox"
                  checked={checked[idx]}
                  onChange={() => toggle(idx)}
                />
                <span>{item}</span>
              </label>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
